import whatIsCryptocurrencyTradingContent from "./content/what-is-cryptocurrency-trading.json";

export const whatIsCryptocurrencyTradingMock = {
  name: "what-is-cryptocurrency-trading",
  layoutType: 1,
  areasList: [
    {
      id: "what-is-cryptocurrency-trading-1",
      name: "what-is-cryptocurrency-trading-content",
      componentName: "Comp:WhatIsCryptocurrencyTradingPage",
      content: JSON.stringify(whatIsCryptocurrencyTradingContent),
    },
  ],
};
